/**
 * Basic back-compat shim for the version 2.x ResponseError type.
 * NOTE: The Request and Response types are *not* the same as previous versions.
 * @deprecated Rely instead on RetryPredicate
 */
export class ResponseError extends Error {
    constructor(message, request, code, response) {
        super(message);
        this.message = message;
        this.request = request;
        this.code = code;
        this.response = response;
    }
}
/**
 * Common HTTP header names.
 */
export var HttpHeader;
(function (HttpHeader) {
    HttpHeader["Accept"] = "Accept";
    HttpHeader["AcceptLanguage"] = "Accept-Language";
    HttpHeader["Authorization"] = "Authorization";
    HttpHeader["ContentLength"] = "Content-Length";
    HttpHeader["ContentType"] = "Content-type";
    HttpHeader["CorrelationVector"] = "MS-CV";
    HttpHeader["XContentRestrictionsHeader"] = "x-xbl-contentrestrictions";
    /**
     * XBL service contract version
     */
    HttpHeader["XXBLContractVersion"] = "X-XBL-Contract-Version";
    /**
     * 2 letter ISO country code matching XBL market
     */
    HttpHeader["XXBLMarket"] = "x-xbl-market";
    HttpHeader["Signature"] = "Signature";
    HttpHeader["XPermissionTicket"] = "X-Permission-Ticket";
    HttpHeader["XDeviceThumbprint"] = "X-Device-Thumbprint";
    HttpHeader["IfNoneMatch"] = "if-none-match";
    HttpHeader["ETag"] = "etag";
    /**
     * https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After
     * Response header generally sent with a 429 or 503.
     * Header value is either a number of seconds, or an HTTP date.
     */
    HttpHeader["RetryAfter"] = "Retry-After";
    /**
     * Request header to inform a service (currently requested for Xbox Live services)
     * that the current request is a retry; starts at 1 and increments from there.
     */
    HttpHeader["RetryCount"] = "Retry-Count";
    HttpHeader["XRewardsCountry"] = "X-Rewards-Country";
    HttpHeader["XRewardsLanguage"] = "X-Rewards-Language";
    HttpHeader["XRewardsIsMobile"] = "X-Rewards-IsMobile";
    HttpHeader["XRewardsAppId"] = "X-Rewards-AppId";
    HttpHeader["XCurrentUser"] = "x-current-user";
})(HttpHeader || (HttpHeader = {}));
//# sourceMappingURL=models.js.map